import $ from 'jquery';
import { initSubmenuExport } from '~core/navbar/submenus/export';
import { generateVideo, showVideoPreview } from '~video';
import { getState } from '~src/state';
import { centerCanvas } from '~core';

export const closeNavbarSubmenu = (submenuTarget) => {
  const targetEl = $(`[data-navbar-submenu="${submenuTarget}"]`);

  if (targetEl.hasClass('active')) {
    targetEl.removeClass('active');
  }
};

const toggleNavbarSubmenu = (event) => {
  // Reset zoom
  centerCanvas();
  const submenuTarget = $(event.currentTarget).data(
    'navbar-submenu-toggle-target'
  );
  $(`[data-navbar-submenu="${submenuTarget}"]`).toggleClass('active');

  if (submenuTarget === 'text-opacity') {
    const buttonWidth = $(event.target).innerWidth();
    const buttonLeftCoord = $(event.target).position().left;
    const selfWidth = $('#navbar-submenu-text-opacity').innerWidth();
    $('#navbar-submenu-text-opacity').css(
      'left',
      buttonLeftCoord + buttonWidth - selfWidth
    );
    $('#navbar-submenu-text-opacity').css('top', 100);
  }
};

const onGiottoVideoPreviewRequest = (event) => {
  event.preventDefault();

  const videoPreviewUrl = getState('videoPreviewUrl');
  const totalChangesSinceLastSave = getState('totalChangesSinceLastSave', 0);

  if (videoPreviewUrl && totalChangesSinceLastSave === 0) {
    showVideoPreview(videoPreviewUrl);
  } else {
    generateVideo({
      isPreview: true,
    });
  }
};

const initSubmenusToggleListener = () => {
  $('body').on(
    'click',
    '[data-navbar-submenu-toggle-target]',
    toggleNavbarSubmenu
  );
  $('body').on('click', '#giotto-video-preview', onGiottoVideoPreviewRequest);
};

export const initAllSubmenus = () => {
  initSubmenusToggleListener();
  initSubmenuExport();

  $('#route-canvas').on('click', () => {
    closeNavbarSubmenu('export');
    closeNavbarSubmenu('text-opacity');
  });
};
